import type { FC } from 'react';
import styles from '../styles/title-box.module.scss';

const TitleBox: FC<{
    className?: string;
    title: string;
}> = ({ className = '', title }) => {
    return <div className={`${styles.titleBox} ${className}`.trim()}>{title}</div>;
};

export default TitleBox;
